import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { ItemBestSellerModel, ItemModel } from "../../infrastructure/model/ProductItemModel";

interface AppItemsContextType {
  items: ItemModel[];
  setItems: React.Dispatch<React.SetStateAction<ItemModel[]>>;
  itemBestSeller: ItemBestSellerModel[];
  setItemBestSeller: React.Dispatch<React.SetStateAction<ItemBestSellerModel[]>>;
}

const AppItemsContext = createContext<AppItemsContextType | undefined>(undefined);

export const AppItemsProvider = ({ children }: { children: ReactNode }) => {
  const [items, setItems] = useState<ItemModel[]>([]);
  const [itemBestSeller, setItemBestSeller] = useState<ItemBestSellerModel[]>([]);
  return (
    <AppItemsContext.Provider value={{ items, setItems, itemBestSeller, setItemBestSeller }}>
      {children}
    </AppItemsContext.Provider>
  );
};

export const useItemsContext = (): AppItemsContextType => {
  const context = useContext(AppItemsContext);
  if (!context) {
    console.error("useItemContext must be used within an AppItemsProvider");
    return {} as AppItemsContextType;
  }
  return context;
};
